<template>
  <el-dialog :title="titleName" class="role-dialog" :visible.sync="dialogFormVisible">
    <el-form :model="form" :rules="rules" ref="ruleForm">
      <el-form-item label="角色名称：" :label-width="formLabelWidth" :required="true" prop="roleName">
        <el-input v-model="form.roleName" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="说明备注：" :label-width="formLabelWidth" :required="true" prop="remark">
        <el-input v-model="form.remark" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="菜单权限：" :label-width="formLabelWidth">
        <el-tree
          :data="menuData"
          default-expand-all
          show-checkbox
          node-key="menuId"
          :default-checked-keys="form.menuIds"
          :props="defaultProps"
          style="height: 450px;"
          ref="tree"
        ></el-tree>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="addAndUpdate('ruleForm')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        dialogFormVisible: true,
        parentNameBool: true,
        titleName: '',
        menuData: [],
        url: '',
        form: {
          roleId: '',
          roleName: '',
          roleSign: '',
          remark: '',
          menuIds: []
        },
        rules: {
          roleName: [{required: true, message: '请输入角色名称', trigger: 'blur'}],
          remark: [{required: true, message: '请输入说明备注', trigger: 'blur'}]
        },
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        formLabelWidth: '120px'
      };
    },
    methods: {
      int(roleId,status) {
        this.getMenuTree();

        this.form.roleId = '';
        this.form.roleName = '';
        this.form.roleSign = '';
        this.form.remark = '';
        this.form.menuIds = [];
        this.$refs['ruleForm'].resetFields();

        if(status==1) {
          this.url = "/business/sys/role/update";
          this.titleName = "角色管理-修改";
          this.$httpTAG({
            url: this.$httpTAG.adornUrl('/business/sys/role/view'),
            method: 'post',
            data: this.$httpTAG.adornData({
              'roleId': roleId
            })
          }).then(r => {
            this.form = r.data.data;
          }).finally(r => {})

        }else if(status==3){
          this.url = "/business/sys/role/save";
          this.titleName = "角色管理-新增";
        }
        this.dialogFormVisible = true;
      },
      getMenuTree() {
        this.$httpTAG({
          url: this.$httpTAG.adornUrl('/business/sys/role/getMenuTree2'),
          method: 'post'
        }).then(r => {
          this.menuData = r.data.data;
        }).finally(r => {})
      },
      addAndUpdate(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.form.menuIds = this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys());//已勾选+半勾选
            this.$httpTAG({
              url: this.$httpTAG.adornUrl(this.url),
              method: 'post',
              data: this.$httpTAG.adornData({
                'roleId': this.form.roleId,
                'roleName': this.form.roleName,
                'roleSign': this.form.roleSign,
                'remark': this.form.remark,
                'menuIds': this.form.menuIds
              })
            }).then(res => {
              if (res.data.code == 0) {
                this.$notify({
                  title: '操作成功！',
                  type: 'success',
                  offset: 600
                });
                this.dialogFormVisible = false
                this.$emit("handleCurrentChange","1");
              } else {
                this.$message({ // 失败
                  type: 'fail',
                  message: res.data.msg
                })
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    }
  };
</script>

<style scoped>

  .role-dialog >>> .el-dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: 0 !important;
    transform: translate(-50%, -50%);
    max-height: calc(100% - 30px);
    max-width: calc(100% - 30px);
    display: flex;
    flex-direction: column;
  }

  .role-dialog >>> .el-dialog__body {
    overflow: auto;
  }

</style>
